module.exports = __webpack_public_path__ + "static/media/dont_forget_to_return_key.d988e5ae.mp3";